module.exports = __webpack_public_path__ + "static/gleev-illustration-91fb48a2d897c63d013bee336178fafe.webp";